import { backofficeFetch } from '@/services/backoffice-api';
import type { GlobalSearchResponse } from './types';
export async function fetchBackofficeGlobalSearch(
  params: URLSearchParams,
  signal?: AbortSignal
): Promise<GlobalSearchResponse> {
  const response = await backofficeFetch(`/search?${params}`, signal ? { signal } : {});
  if (!response.ok) throw new Error('Failed to search');
  return response.json() as Promise<GlobalSearchResponse>;
}
